import { render, staticRenderFns } from "./JobActivityFeed.vue?vue&type=template&id=428fe98a&scoped=true"
import script from "./JobActivityFeed.vue?vue&type=script&lang=js"
export * from "./JobActivityFeed.vue?vue&type=script&lang=js"
import style0 from "./JobActivityFeed.vue?vue&type=style&index=0&id=428fe98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428fe98a",
  null
  
)

export default component.exports